import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'

const AdvertisementText = ({ className, placement = 'left' }) => {
  return (
    <span
      className={cx(styles.advertisementText, className, {
        [styles.left]: placement === 'left',
        [styles.right]: placement === 'right',
      })}
    >
      Advertisement
    </span>
  )
}

AdvertisementText.propTypes = {
  className: PropTypes.string,
  placement: PropTypes.oneOf(['left', 'right']),
}

export default AdvertisementText
